import { render, staticRenderFns } from "./ModalPrensa.vue?vue&type=template&id=e902206a"
import script from "./ModalPrensa.vue?vue&type=script&lang=js"
export * from "./ModalPrensa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports